import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Load all JSON files:
// ./locales/ar/menu.json
// ./locales/ar/register.json
// ./locales/en/menu.json
// ./locales/en/register.json
const modules = import.meta.glob(
  "./locales/*/*.json",
  {
    eager: true,
  }
);

const resources: Record<
  string,
  Record<string, Record<string, any>>
> = {};

Object.entries(modules).forEach(([path, mod]) => {
  // Example:
  // path = "./locales/en/menu.json"

  const match = path.match(
    /^\.\/locales\/([^/]+)\/([^/]+)\.json$/
  );

  if (!match) {
    console.warn("Could not match translation file:", path);
    return;
  }

  const [, lang, namespace] = match;

  resources[lang] ??= {};

  resources[lang][namespace] = (
    mod as { default: Record<string, any> }
  ).default;
});

// console.log("i18n resources:", resources);

const allNS = Object.values(resources).flatMap(
  (langObj) => Object.keys(langObj)
);

const uniqueNS = [...new Set(allNS)];

i18n
  .use(initReactI18next)
  .init({
    resources,

    lng:
      localStorage.getItem("preferredLanguage") || "ar",

    fallbackLng: "en",

    defaultNS: "register",

    ns: uniqueNS,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
